import React from 'react';

import './RothDailyMinMaxModal.scss';

import Button from '../../../Shared/Button/Button';

const RothDailyMinMaxModal = ({ closeModal }) => {
  return (
    <div className="roth-daily-minmax-container">
      <p className="roth-daily-minmax-heading">
        Your Daily Minimums &amp; Maximums
      </p>
      <p className="roth-daily-minmax-modal-sub-header">
        <b>The minimum value</b> that can be exchanged from a fund is $0.01 or
        $0.01 worth of shares.
      </p>
      <p>
        <b>Fund Maximum Threshold -</b> To account for market fluctuations,
        exchange maximums are imposed for dollar amounts and determined by
        individual funds. In volatile market conditions, the permitted maximum
        dollar amount may allow you to enter an exchange amount that is more
        than the fund's day-end balance. If your exchange value is higher than
        your day-end balance, your transaction will fail and not be executed.
        Avoid this scenario by entering an exchange value in{' '}
        <b>percentage or number of shares.</b>
      </p>
      <div className="roth-daily-minmax-button-container">
        <Button
          id="exchange-change-amount-btn"
          buttonType="primary"
          onClick={() => {
            closeModal();
          }}
        >
          Ok
        </Button>
      </div>
    </div>
  );
};

export default RothDailyMinMaxModal;
